<script>
import Icon from 'icons/svg/sellsyCloudTransparentBg.svg';
export default {
    components: {
        Icon,
    },
    template: '<Icon></Icon>',
};
</script>
